export const FALLBACK_LOCALE = "en-US";

/** BCP 47 language tag: language with optional script, region, and extensions. */
const BCP47_LOCALE_PATTERN = /^[a-zA-Z]{2,3}(-[a-zA-Z0-9]{2,8})*$/;

function getSupportedLocales(supportedLngs: readonly string[]) {
  return supportedLngs.filter((lng) => lng !== "cimode");
}

/**
 * Maps a Trimble profile locale to the i18n language tag to load.
 * Unset, invalid, or unsupported profile values fall back to {@link FALLBACK_LOCALE}.
 */
export function resolveProfileLocale(
  rawLocale: string | undefined,
  supportedLngs: readonly string[]
): string {
  if (rawLocale === undefined) {
    return FALLBACK_LOCALE;
  }

  const trimmed = rawLocale.trim();
  if (trimmed === "" || !BCP47_LOCALE_PATTERN.test(trimmed)) {
    return FALLBACK_LOCALE;
  }

  const supported = getSupportedLocales(supportedLngs);
  if (!supported.includes(trimmed)) {
    return FALLBACK_LOCALE;
  }

  return trimmed;
}
